module.exports = __webpack_public_path__ + "img/cityscape-aerial-view.00e490b1.jpg";